import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <a href="#" rel="noopener noreferrer">
         {process.env.REACT_APP_SITE_NAME}
        </a>
        <span className="ms-1">&copy; {new Date().getFullYear()}.</span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Powered by</span>
        <a href="https://www.klientotech.com" target="_blank" rel="noopener noreferrer">
          KT
        </a>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
